import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Left } from "../../../../src/icons/left.svg";
import { ReactComponent as Refresh } from "../../../../src/icons/refresh.svg";
import { ReactComponent as Moon } from "../../../../src/icons/moon-theme.svg";
import { ReactComponent as Sun } from "../../../../src/icons/sun-theme.svg";
import { useDispatch, useSelector } from "react-redux";
import {switchThemeAction, updateProfileCompleteAction,} from "../../../store/actions/AuthActions";
import {saveProfileInLocalStorage, submitProfile,} from "../../../services/AuthService";
import indexedDBService from "../../../services/IndexedDBService";

const BottomNav = () => {
  const history = useHistory();
  const store = useSelector((store) => store.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const handler = (event) => {
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (data?.type === "switchTheme") {
          switchTheme();
        }
      } catch (e) {
        console.error("Invalid postMessage:", e);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [store.auth.idToken]);

  async function switchTheme() {
    let dataAttr = document.querySelector("body");
    const newTheme = dataAttr.getAttribute('data-theme-version') === 'dark' ? 'light' : 'dark';
    dataAttr.setAttribute('data-theme-version', newTheme);
    if (!!store.auth.idToken) {
      submitProfile({theme: newTheme}).then((response) => {
        saveProfileInLocalStorage(response.data.profile, response.data.restaurants);
        dispatch(updateProfileCompleteAction(response.data.profile, response.data.restaurants));
      })
    } else {
      let old = await indexedDBService.getUserData('userDetails');
      if (old === null) {
        old = {};
      }
      const newDetails = {
        ...old,
        userData: {
          ...old.userData,
          theme: newTheme,
        },
      };
      await indexedDBService.setUserData('userDetails', newDetails);
      dispatch(switchThemeAction(newTheme))
    }
  }

  return (
    <div className="bottom-nav">
      <Left onClick={() => history.goBack()} />
      <Refresh onClick={() => window.location.reload()} />
      {!!store.auth.userData && store.auth.userData.theme === "dark" ? (
        <Sun onClick={switchTheme} style={{ width: 30, height: 30 }} />
      ) : (
        <Moon onClick={switchTheme} style={{ width: 30, height: 30 }} />
      )}
    </div>
  );
};

export default BottomNav;
